mutation PauseAutomatedEmails {
    pauseAutomatedEmails {
        user {
            id
        }
    }
}
